export const cacheKeys = {
  createFeedback: 'createFeedback',
  editFeedback: 'editFeedback',
};
